import { html, nothing } from "lit";
import type { MockClass } from "../data/mock-schedule";

export const offeringLabel = (occurrence: MockClass): string => {
  if (occurrence.offeringKind === "event") return "Event";
  if (occurrence.offeringKind !== "program") return "";
  return occurrence.programSessionOrdinal && occurrence.programSessionCount
    ? `Program · ${occurrence.programSessionOrdinal} of ${occurrence.programSessionCount}`
    : "Program";
};

export const renderOfferingBadge = (occurrence: MockClass) => {
  const label = offeringLabel(occurrence);
  return label ? html`<span class="offering-badge">${label}</span>` : nothing;
};
